import { render } from "./labelling.vue?vue&type=template&id=37d06877&scoped=true"
import script from "./labelling.vue?vue&type=script&lang=js"
export * from "./labelling.vue?vue&type=script&lang=js"

import "./labelling.vue?vue&type=style&index=0&id=37d06877&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-37d06877"

export default script